import "element-ui/lib/theme-chalk/index.css";
import Vue from 'vue'
import App from './App.vue'

import router from "./router";
import store from './store/store';
import ElementUI from "element-ui";

import './icons';

// 引入jquery
import $ from './utils/jquery.js';
import global_ from './utils/Global.js'//引用文件，设置全局变量

// 配置axios
// import Axios from 'axios'
import myhttp from "@/utils/http.js";
Vue.prototype.$post = myhttp.post;
Vue.prototype.$get = myhttp.get;

Vue.prototype.$postfile = myhttp.postfile;

// Vue.prototype.GLOBAL = global_//把全局变量挂载到Vue实例上面

// 註冊 饿了么 UI
Vue.use(ElementUI);
Vue.prototype.GLOBAL = global_//把全局变量挂载到Vue实例上面

Vue.config.productionTip = false

new Vue({
	router,
	store:store,
  render: h => h(App),
}).$mount('#app')
